import React, { ReactElement } from "react";
import ReturnSalesCategoryWiseReportList from "../../components/Reports/ReturnSalesCategoryWiseReportList";
import MainLayout from "../../components/Layouts";

const ReturnSalesCategoryWiseReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <ReturnSalesCategoryWiseReportList />
    </MainLayout>
  );
}; 

export default ReturnSalesCategoryWiseReportPage;
